class PulsoEmailPopup extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'pulsoPopupDismissedUntil';
    this.overlay = this.querySelector('[data-pulso-popup-overlay]');
    this.closeButtons = this.querySelectorAll('[data-pulso-popup-close]');
    this.copyButton = this.querySelector('[data-pulso-copy-code]');
  }

  connectedCallback() {
    this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.hide(true)));
    if (this.overlay) this.overlay.addEventListener('click', () => this.hide(true));

    this.handleKeydown = (event) => {
      if (event.key === 'Escape') this.hide(true);
    };
    document.addEventListener('keydown', this.handleKeydown);

    if (this.copyButton) {
      this.copyButton.addEventListener('click', () => this.copyCode());
    }

    const posted = this.dataset.posted === 'true';
    if (posted) {
      this.show();
      return;
    }

    if (this.isDismissed()) return;

    const delay = parseInt(this.dataset.delay, 10) || 0;
    this.timeoutId = window.setTimeout(() => this.show(), delay);
  }

  disconnectedCallback() {
    if (this.timeoutId) window.clearTimeout(this.timeoutId);
    if (this.handleKeydown) document.removeEventListener('keydown', this.handleKeydown);
  }

  isDismissed() {
    try {
      const until = window.localStorage.getItem(this.storageKey);
      if (!until) return false;
      return Date.now() < parseInt(until, 10);
    } catch (error) {
      return false;
    }
  }

  show() {
    this.classList.add('is-visible');
    document.body.classList.add('pulso-popup-open');
  }

  hide(remember) {
    this.classList.remove('is-visible');
    document.body.classList.remove('pulso-popup-open');
    if (remember) {
      try {
        const days = parseInt(this.dataset.hideDays, 10) || 30;
        const until = Date.now() + days * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(this.storageKey, String(until));
      } catch (error) {
        /* localStorage unavailable */
      }
    }
  }

  copyCode() {
    const code = this.copyButton.dataset.code;
    if (!code) return;
    const done = () => {
      const original = this.copyButton.textContent;
      this.copyButton.textContent = 'Copiado';
      window.setTimeout(() => {
        this.copyButton.textContent = original;
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(() => {});
    }
  }
}

customElements.define('pulso-email-popup', PulsoEmailPopup);
